export default __webpack_public_path__ + "static/g401-dcc7039ccea8785e5660e8d9f0ef0a15.jpg";